import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const OpenInNewIcon = (props: IconProps) => (
  <Icon w="20px" h="20px" viewBox="0 0 20 20" {...props}>
    <path d="M15.8333 15.8333H4.16667V4.16667H10V2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10H15.8333V15.8333ZM11.6667 2.5V4.16667H14.6583L6.46667 12.3583L7.64167 13.5333L15.8333 5.34167V8.33333H17.5V2.5H11.6667Z" />
  </Icon>
);

export default memo(OpenInNewIcon);
